function markDevAutoSkipped(stepEl, reason) {
   if (!stepEl || stepEl.querySelector('.wccp-dev-autoskip-note')) return;

   const note = document.createElement('div');
   note.className = 'wccp-dev-autoskip-note';
   note.style.cssText =
     'padding:8px 10px;' +
     'margin-bottom:10px;' +
     'background:#fff3cd;' +
     'border:1px dashed #856404;' +
     'color:#856404;' +
     'font-size:13px;';

   note.textContent =
     'DEV MODE: normally auto-selected / auto-skipped, but blocked';

   stepEl.prepend(note);

   window.WCCP_DEV_CONSOLE?.log(
     'AUTO_SKIPPED_IN_PRODUCTION',
     {
       component_id: stepEl.dataset.item_id,
       step: stepEl.dataset.step,
       reason
     }
   );
 }


async function autoSelectAndSkipIfSingle(stepEl, idx) {
    const cid = Number(stepEl.dataset.item_id);

    if (cid === STATE.accessories_step_id) {
        return false;
    }

    // DEV: block auto-select except simple steps
    const devIgnore = devIgnoreHiding();

    // WAIT for STATE
    if (typeof window.STATE === 'undefined' || !window.STATE.data) {
        return false;
    }

    if (!stepEl) return false;

    await narrowIfNeededForStep(stepEl);
    await ensureVariationsForStep(stepEl);

    const compId = Number(stepEl.dataset.item_id);
    const allowedSet = computeAllowedByComponent().get(compId) || new Set();
    const isLast = isLastStep(idx);

    // console.log("AUTOSELECT CHECK", {
    //     compId,
    //     idx,
    //     isLast,
    //     stepEl,
    // });

    const options = qsa(selFor(CLASSES.option), stepEl).filter(opt =>
        allowedSet.has(Number(opt.dataset.productId))
    );

    // DEV LOG: scenario hidden (no allowed products)
    if (
        allowedSet.size === 0 &&
        window.WCCP_DEV_MODE?.debug?.componentSkip
    ) {
        devLog('FILTER_COMPONENT_SKIP', {
            component_id: compId,
            step: stepEl.dataset.step,
            reason_code: 'scenario_hidden',
            reason: 'Component hidden by scenarios (no allowed products)',
            allowed_product_ids: [],
            effects: window.WCCP_DEBUG?.scenarioEffectsByComponent?.[compId] || [],
            source: 'autoSelectAndSkipIfSingle'
        });
    }

    if (options.length === 0 && isLast) {
        // console.log('no options to select and is last step, hiding step');
        if (devIgnore) {
            // console.log("DEV MODE - no options to select and is last step, hiding step");
            window.WCCP_DEV_CONSOLE?.log("IGNORE_HIDING", "autoSelectAndSkipIfSingle skipped hiding last step with no options to select");
        }
        stepEl.style.display = 'none';
        updateStepNavButtons(stepEl);
        await finalizeLastStep(stepEl, idx);
        return true;
    }

    if (options.length === 0) {
        // console.log('no options to select, hiding step');

        delete STATE.selected[compId];
        delete STATE.selectedVariants[compId];
        if (devIgnore) {
            // console.log("DEV MODE - no options to select, hiding step");
            window.WCCP_DEV_CONSOLE?.log("IGNORE_HIDING", "autoSelectAndSkipIfSingle skipped hiding step with no options to select");
            stepEl.style.display = 'block';
            updateStepNavButtons(stepEl);
            return false;
        }
        return true;
    }
    if (options.length !== 1) {
        // console.log('multiple options to select, not auto-selecting');
        if (devIgnore) {
            // console.log("DEV MODE - multiple options to select, not auto-selecting");
            window.WCCP_DEV_CONSOLE?.log("IGNORE_HIDING", "autoSelectAndSkipIfSingle skipped hiding step with multiple options to select");
        }
        return false;
    }

    // === DEV LOG: single allowed option auto-selected (skip) ===
    if (options.length === 1 && !devBlockAutoSelectSimpleForStep(stepEl)) {
        const shouldLogAutoSkip =
                devIgnoreHiding() ||
                window.WCCP_DEV_MODE?.debug?.componentSkip ||
                window.WCCP_DEV_MODE?.debug?.allowedComponents;
        if (shouldLogAutoSkip) {
            devLog('AUTO_COMPONENT_SKIP', {
                component_id: compId,
                step: stepEl.dataset.step,
                reason_code: 'auto_skipped',
                reason: 'Single allowed option auto-selected',
                allowed_product_ids: [...allowedSet],
                source: 'autoSelectAndSkipIfSingle'
            });
        }
        

        // === DEV LOG: scenarios/effects snapshot for this auto-skipped step ===
        if (
            window.WCCP_DEV_MODE?.debug?.triggeredScenarios &&
            options.length === 1 &&
            !devBlockAutoSelectSimpleForStep(stepEl)
        ) {
            // important: computeAllowedByComponent() was already called above via allowedSet, 
            // and it also fills window.WCCP_DEBUG.scenarioEffectsByComponent
            const matched = (typeof getStableMatchedScenarios === 'function')
                ? getStableMatchedScenarios()
                : (typeof getMatchedScenarios === 'function' ? getMatchedScenarios() : []);

            const effects =
                window.WCCP_DEBUG?.scenarioEffectsByComponent?.[compId] || [];

            // compute allowed product IDs from effects
            // devLog('AUTO_COMPONENT_SKIP_SCENARIOS', {
            //     step: Number(stepEl.dataset.step),
            //     component_id: compId,
            //     // what has already been selected above the chain
            //     selected_upstream: JSON.parse(JSON.stringify(STATE.selected)),
            //     // ALL scenarios that matched the conditions
            //     // scenario_ids_matched: (matched || []).map(
            //     //     s => s.id || s.scenario_id || s.name
            //     // ),
            //     // ONLY scenarios that actually affected the component
            //     scenario_ids_affecting_component: effects.map(e => e.scenarioId),
            //     // scenario_ids: (matched || []).map(s => s.id || s.scenario_id || s.name),
            //     // effects,
            //     // allowed_product_ids: [...allowedSet],
            //     source: 'autoSelectAndSkipIfSingle'
            // });
        }
    }

    const onlyOpt = options[0];
    const pid     = Number(onlyOpt.dataset.productId);

    const isSimpleStep = !stepHasVariationSelect(stepEl);
    const blockSimpleByDev = devBlockAutoSelectSimple() && isSimpleStep;

    if (!blockSimpleByDev) {
        qsa(selFor(CLASSES.option), stepEl)
            .forEach(o => o.classList.remove(CLASSES.selected));
        onlyOpt.classList.add(CLASSES.selected);
        STATE.selected[compId] = pid;
        if (window.WCCP_CONSTRUCTOR_UPDATE) {
            window.WCCP_CONSTRUCTOR_UPDATE();
        }
    } else {
        markDevAutoSkipped(stepEl, 'simple-autoselect-blocked');
    }

    // DEV: if we block autoselection of simple steps, the step must remain visible
    if (blockSimpleByDev) {
        // console.log("DEV MODE: simple step autoselect blocked — keep step visible", { compId, idx });
        markDevAutoSkipped(stepEl, 'simple-autoselect-blocked');

        stepEl.style.display = 'block';
        updateStepNavButtons(stepEl);
        disableNextButtonIfNoSelection(stepEl); // Next be disabled until it is selected
        return false; // We do not skip a step.
    }

    // DEV: Log state update
    function getStateSnapshot() {
        return {
            selected: { ...STATE.selected },
            selectedVariants: { ...STATE.selectedVariants },
            selectedQty: { ...STATE.selectedQty }
        };
    }


    if (window.WCCP_DEV_MODE?.debug?.stateInfo) {
        // console.log('state info click', STATE);
        window.WCCP_DEV_CONSOLE?.log("STATE_UPDATE", {
            source: "autoSelectAndSkipIfSingle",
            state: getStateSnapshot(),
            data: {
                product_id: STATE.data?.product_id,
                components_count: STATE.data?.components?.length || 0,
                scenarios_count: STATE.data?.scenarios?.length || 0,
                component_ids: STATE.data?.components?.map(c => c.id),
                scenario_ids: STATE.data?.scenarios?.map(s => s.id || s.scenario_id)
            }
        });
    }

    if (!STATE.selectedQty) STATE.selectedQty = {};

    const qInfo = getQtyForComponent(compId, pid);
    STATE.selectedQty[compId] = qInfo.min_qty ?? 1;

    const sel = onlyOpt.querySelector('.wccp-variation-select');
    if (sel) {
        if (!sel.value) {
            const valid = Array.from(sel.options).filter(o => o.value);
            if (valid.length === 1) {
                sel.value = valid[0].value;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
        STATE.selectedVariants[compId] = sel.value ? Number(sel.value) : undefined;
    } else {
        delete STATE.selectedVariants[compId];
    }


    if (!devIgnore) {
        stepEl.style.display = 'none';

        if (isLast) {
            updateStepNavButtons(stepEl);
            await finalizeLastStep(stepEl, idx);
            return true;
        }
        return true;
    } else {
        // console.log("DEV MODE AUTOSELECT");
        if (devBlockAutoSelectSimpleForStep(stepEl)) {
            // console.log("DEV MODE AUTOSELECT 1 - blocking hiding");
            markDevAutoSkipped(stepEl, 'single-option');
            stepEl.style.display = 'block';
            updateStepNavButtons(stepEl);
            return false;
        }
        
        // DEV MODE — we show the step, but do not mutate the STATE
        window.WCCP_DEV_CONSOLE?.log("IGNORE_HIDING", "autoSelectAndSkipIfSingle skipped hiding");
        stepEl.style.display = 'block';
        updateStepNavButtons(stepEl);
        return false;
    }

    // window.WCCP_TIMING.logHiddenStep(stepEl.dataset.item_id);

    // return true;
}
